import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { motion } from "framer-motion";

export default function FinalCTA() {
  return (
    <Box
      sx={{
        py: 10,
        px: 2,
        background: "linear-gradient(to right, #1976d2, #42a5f5)",
        color: "white",
        textAlign: "center",
      }}
    >
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Ready to Take Control of Your Health?
          </Typography>
          <Typography variant="body1" sx={{ mb: 4 }}>
            Track your lab results. Understand your body. Stay one step ahead.
          </Typography>
          <Button
            variant="contained"
            size="large"
            color="secondary"
            sx={{ fontWeight: "bold" }}
            href="/tracker"
          >
            Start Now
          </Button>
        </motion.div>
      </Container>
    </Box>
  );
}